import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {SepaImportError} from '../../../dto/sepa-import-error';
import {MatTab} from '@angular/material/tabs';
import {CreateCardBatchListItem} from '../../../models/create-card/create-card';
import {toDateString} from '../../../providers/app-date-adapter';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {Referral} from '../../../dto/order';
import {Card} from '../../../dto/card';
import {CreateCardService} from '../../services/create-card.service';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {MultiCrudDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {ActivatedRoute, Router} from '@angular/router';
import {AppMatCustomAction} from '../../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import {TrustPayTransaction} from '../../../dto/trustPayTransaction';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {RoleService} from '../../../services/role.service';
import {DatePipe} from '@angular/common';
import {ToastService} from 'angular-toastify';
import {CardsService} from '../../services/cards.service';

@Component({
  selector: 'app-card-creations',
  templateUrl: './card-creations.component.html',
  styleUrls: ['./card-creations.component.css']
})
export class CardCreationsComponent implements OnInit {
  dataSource: MultiCrudDataSource<CreateCardBatchListItem>;

  isExecutingBatch = false;
  pollInterval: ReturnType<typeof setTimeout>|null = null;

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  constructor(
    private createCardService: CreateCardService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private roleService: RoleService,
    private datePipe: DatePipe,
    private _toastService: ToastService,
    private cardsService: CardsService,
  ) {

    this.dataSource = new MultiCrudDataSource(this.createCardService);
  }

  ngOnInit(): void {
    this.rebuildCustomActions();
  }

  rebuildCustomActions() {
    if (this.roleService.hasRoles('admin')) {
      this.createBatchCustomActions = [
        new AppMatCustomAction('⏩', 'Execute this batch', false, (row: CreateCardBatchListItem) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Execute card creation batch',
              text: 'Are you sure you want to execute batch '+row.id+'?'
            },
            minWidth: 350,
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.executeCardCreateBatch(row.id);
              }
            });
        }, (row: CreateCardBatchListItem) => row.processing || row.complete  || this.isExecutingBatch, true),
        new AppMatCustomAction('🔄', 'Import success cards', false, (row: CreateCardBatchListItem) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Import success cards',
              text: 'Are you sure you want to import success cards from batch '+row.id+'?'
            },
            minWidth: 350,
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.importSuccessCards(row.id);
              }
            });
        }, (row: CreateCardBatchListItem) => !row.complete || row.imported || this.isExecutingBatch, true)

      ];
    }
  }

  loadData() {

  }

  columns = [
    { columnDef: 'id', header: 'ID', cell: row => row.id.toString() } as ContentRowField<CreateCardBatchListItem>,
    { sortable: false, columnDef: 'timestamp', header: 'Date', cell: row => this.datePipe.transform(row.timestamp, 'yyyy-MM-dd HH:mm') } as ContentRowField<CreateCardBatchListItem>,
    { sortable: false, columnDef: 'cardCount', header: 'Number of cards', cell: row => row.cardCount.toString() } as ContentRowField<CreateCardBatchListItem>,
    { sortable: false, columnDef: 'status', header: 'Status', cell: row => {

      if ( row.imported ) {
return '✅ Imported';
}
      if ( row.processing ) {
return '⚙️';
}
      if ( row.complete ) {
return '🧮 Processed';
}


      return '⚪️ Pending';
      }

    } as ContentRowField<CreateCardBatchListItem>,

];

  editEnabled() {
return false;
  }

  deleteEnabled() {
return false;
  }

  multiselectEnabled() {
return false;
  }

  public dialogRemoveText = 'Are you sure you want to delete this batch?';

  getViewLink = (item: CreateCardBatchListItem): string => item.id.toString();

  getEditLink = (item: CreateCardBatchListItem): string => item.id.toString() + '/edit';
  createBatchCustomActions: any[] = [];

  returnBack() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }

  private pollBatch(id: number) {

    this.createCardService.get(id).subscribe(b => {
      if ( !b.processing ) {
        clearInterval(this.pollInterval);
        this._toastService.success('Batch ' + id + ' was processed');
        this.dataSource.loadData();
        this.pollInterval = null;
      }


    });
  }

  private executeCardCreateBatch(batchId: number) {
    this.isExecutingBatch = true;

    this.cardsService.executeCreateCardBatch(batchId).subscribe(data => {

      this._toastService.info('Processing batch ' + batchId + '...');

      this.pollInterval = setInterval(() => this.pollBatch(batchId), 2000);

    }, err => {
      this._toastService.error(err.error.message || err.message || err.error || err);
    });


  }

  private importSuccessCards(batchId: number) {
    this.isExecutingBatch = true;

    this._toastService.info('Importing cards from batch ' + batchId + '...');
    this.cardsService.importSuccessCardsFromCardCreateBatch(batchId).subscribe(_ => {
      this._toastService.success('Imported cards from batch ' + batchId + '');
      this.isExecutingBatch = false;
      this.dataSource.loadData();
    }, err => {
      this._toastService.error(err.error.message || err.message || err.error || err);
      this.isExecutingBatch = false;
    });


  }



}
